import React from "react"
import "./footer.css"

export const Footer = () => {
  return (
    <div className="footer text-light  py-2">
      <p> Admin Panel CMS Version 1.0.1</p>
    </div>
  )
}
